export enum MemberStatusType {
    Active = 0,
    Cancelled = 1,
    UnconfirmedEmail = 2,
    UnconfirmedInitialPayment = 3,
}